import { SET_LOCALE } from "../constants/action-types";

export const setLanguage = (data) => (dispatch) => {
  dispatch({
    type: SET_LOCALE,
    payload: data,
  });
};
